module.exports = __webpack_public_path__ + "img/P11-zh.f15504cd.png";